export default __webpack_public_path__ + "static/media/11H.12a9035b.webp";